import { Paper as MantinePaper, PaperProps } from '@mantine/core';
import { PolymorphicComponentProps } from '@mantine/core/lib/core/factory/create-polymorphic-component';

const Paper = (props: PolymorphicComponentProps<'div', PaperProps>) => {
  return <MantinePaper shadow='none' radius='sm' withBorder {...props} />;
};

export default Paper;
